/*
 *   File : external-holdings.js
 *   Author : https://evoqins.com
 *   Description : External holdings page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment } from 'react';

//Custom components
import { PortfolioHoldingsCard } from '../../../Components/Card';

const ExternalHoldings = ({ portfolioDetails, toggleXirr }) => {
    return (
        <Fragment>
            <div className={`row g-3`}>
                {portfolioDetails?.summary?.map((fund, key) => (
                    <div key={key} className='col-6'>
                        <PortfolioHoldingsCard type={4}
                            data={fund}
                            toggleXirr={toggleXirr} />
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default ExternalHoldings;
